import { render, staticRenderFns } from "./UserContact.vue?vue&type=template&id=29d94bd5"
import script from "./UserContact.vue?vue&type=script&lang=js"
export * from "./UserContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports